<template>
  <jump-header />
  <div class="columns-play" :style="{ background: playInfo.bgColour }">
    <div class="page-body">
      <div
        class="column-wrapper"
        :style="{
          background: playInfo.bgColourOpacity,
          filter: 'brightness(150%)',
        }"
      >
        <div class="img-wrapper">
          <img :src="playInfo.pictureUrl" alt="专辑封面图" />
          <div class="play-num-wrapper">
            <img src="~@/assets/image/play-pain.png" alt="播放次数图标" />
            <span>{{ playInfo._clickSum }}</span>
          </div>
        </div>
      </div>
      <div class="column-content">
        <div class="column-title text-line-1">
          {{ playInfo.name }}
        </div>
        <div class="column-intro">
          <span class="text-line-1">{{ playInfo.introduction || playInfo.name }}</span>
          <div
            class="column-intro-btn"
            v-if="showIntroBtn"
            :style="{
              background: playInfo.bgColour,
              filter: 'brightness(150%)',
            }"
            @click="toHtmlUrl"
          >
            <span>查看完整简介</span>
            <i class="v-icon-arrow-right icon-class" />
          </div>
        </div>
        <div class="column-tag">
          <div
            class="column-tag-star"
            :style="{
              background: playInfo.bgColour,
              filter: 'brightness(150%)',
            }"
          >
            ⭐
            <span>{{ averageScore }}</span>
          </div>
          <div
            class="column-tag-num"
            @click="handleClickMoreIcon"
            :style="{
              background: playInfo.bgColour,
              filter: 'brightness(150%)',
            }"
          >
            <span>{{ rankInfo }}</span>
          </div>
        </div>
        <div class="column-name">{{ playInfo.columnsName }}</div>
      </div>
      <div class="slider-wrapper">
        <!-- <span class="slider-current">{{ showCurrentTime }}</span> -->
        <van-slider
          v-model="progressNum"
          active-color="#fefefe"
          inactive-color="#7F868F"
          @change="onChangeSlider"
          @drag-start="dragStart"
          @update:model-value="sliderModelValue"
        >
          <template #button>
            <div class="custom-button">
              {{ showCurrentTime }}
            </div>
          </template>
        </van-slider>
        <span class="slider-total">{{ showDuration }}</span>
      </div>
      <div class="options-wrapper">
        <div class="options-wrapper-btn" @click="changePlayType">
          <img class="options-wrapper-btn-img" :src="playTypeImgMap[playType]" alt="" />
          <transition name="popup">
            <div class="playtype-tip" v-if="showPlayTypeTip">
              {{ playTypeName }}
            </div>
          </transition>
        </div>
        <div class="options-wrapper-btn" @click="handleClickPrevIcon">
          <i class="v-icon-play-prev options-icon" />
        </div>
        <div class="options-wrapper-btn" @click="changePlayStatus">
          <i :class="[playStatus, 'play-icon']" />
          <canvas v-show="showCanvasLoading" id="canvas" width="60" height="60" />
        </div>
        <div class="options-wrapper-btn" @click="handleClickNextIcon">
          <i class="v-icon-play-next options-icon" />
        </div>
        <div class="options-wrapper-btn" @click="showProgramListPopup">
          <i class="v-icon-list options-icon" />
        </div>
      </div>
    </div>
    <van-popup
      v-model:show="showColumnListPopup"
      round
      position="bottom"
      :style="{
        height: '500px',
        zIndex: '9999',
        maxWidth: '500px',
        left: '50%',
        marginLeft: `-${innerWidth > 500 ? '250' : innerWidth / 2}px`,
      }"
    >
      <div class="popup-wrapper">
        <div class="popup-header">
          <div class="header-title text-line-1">
            当前播放-
            <span class="header-title-name text-line-1">{{ playInfo.name }}</span>
          </div>
          <div class="header-options">
            <div>{{ playTypeName }}</div>
            <div class="header-options-sort" @click="changeSort">
              <img :src="order === -1 ? sortDownImg : sortUpImg" alt="" />
              <span>{{ order === -1 ? "倒序" : "正序" }}</span>
            </div>
          </div>
        </div>
        <div class="popup-content">
          <van-list
            finished-text="(`へ´) 我是一个有底线的人"
            v-model:loading="listLoading"
            :finished="isFinished"
            @load="loadList"
          >
            <div
              class="popup-content-item"
              v-for="(item, index) in programList"
              :key="item.id"
              @click="handleClickPgcItem(item)"
            >
              <div class="content-item-num">
                <span v-if="playInfo.id !== item.id">{{ index + 1 }}</span>
                <div v-if="playInfo.id === item.id">
                  <playing-icon />
                </div>
              </div>
              <div
                :class="[
                  'content-item-name',
                  'text-line-1',
                  playInfo.id === item.id ? 'content-item-name-active' : '',
                ]"
              >
                {{ item.name }}
              </div>
            </div>
          </van-list>
        </div>
        <div class="popup-bottom" @click="showColumnListPopup = false">关闭</div>
      </div>
    </van-popup>
    <audio
      ref="audioRef"
      @pause="pause"
      @canplay="ready"
      @error="error"
      @timeupdate="updateTime"
      @ended="end"
    ></audio>
  </div>
</template>

<script>
import { Dialog } from "vant";
import wxSdk from "@/http/wxApi.js";
import { useRoute } from "vue-router";
import { shuffle } from "@/assets/js/util";
import JumpHeader from "@/components/Base/JumpHeader";
import { defineComponent, onMounted, ref, watch } from "vue";
import PlayingIcon from "@/components/Base/PlayingIcon";
import {
  queryHistoryProgramByName,
  queryColumnsAverageScore,
  queryColumnRankInCategory,
  queryAllIdByColumnsId,
} from "@/http/api.js";
import { log } from "video.js";

export default defineComponent({
  name: "ColumnsPlay",
  components: {
    PlayingIcon,
    JumpHeader,
  },
  setup() {
    const route = useRoute();
    const playInfo = ref({});
    const rankInfo = ref("");
    const innerWidth = ref(0);
    const audioRef = ref(null);
    const averageScore = ref("");
    const isFirstTime = ref(true);
    const showIntroBtn = ref(false);
    const showDuration = ref("00:00");
    const showCanvasLoading = ref(false);

    innerWidth.value = window.innerWidth;

    const getProgramInfo = async (id) => {
      const result = await queryHistoryProgramByName({
        flag: "play",
        id: id,
        page: 1,
        rows: 10,
        order: 1,
      });
      playInfo.value = result.data.pageList[0];
      playInfo.value.bgColour = playInfo.value.bgColour.replace(/\s/g, "");
      playInfo.value.bgColourOpacity = `rgba(${playInfo.value.bgColour
        .substring(4)
        .replace(/\)/, "")},0.6)`;
      playInfo.value._clickSum = filterNum(playInfo.value.clickSum);
      audioRef.value.src = playInfo.value.audioViderUrl;
      if (isFirstTime.value) {
        Dialog.confirm({
          title: "是否播放该音频",
        })
          .then(() => {
            // on confirm
            audioRef.value.play();
            isFirstTime.value = false;
          })
          .catch(() => {
            // on cancel
          });
      }
      if (
        playInfo.value.introduction != null &&
        playInfo.value.introduction != "" &&
        playInfo.value.introduction.length > 1
      ) {
        showIntroBtn.value = true;
      }
    };

    const filterNum = (val) => {
      if (val > 10000) {
        return `${(val / 10000).toFixed(2)}万`;
      }
      return val;
    };

    const { ...useOptionsWrapperLogicProps } = useOptionsWrapperLogic(
      route,
      audioRef,
      playInfo,
      showCanvasLoading,
      getProgramInfo
    );

    const { ...usePopupLogicProps } = usePopupLogic(playInfo, getProgramInfo);

    const getAverageScore = async () => {
      const result = await queryColumnsAverageScore({
        operateType: 3,
        operateId: route.query.columnsId,
      });
      averageScore.value = result.data.toFixed(1);
    };

    const getRankInfo = async () => {
      const result = await queryColumnRankInCategory({
        columnsId: playInfo.value.columnsId,
      });
      if (result.code === 1) {
        rankInfo.value = `${result.name} No.${result.rank}`;
      }
    };

    const toHtmlUrl = () => {
      window.location.href = playInfo.value.htmlUrl;
    };

    const getDuration = () => {
      let totalSec = playInfo.value.duration;
      const sec = totalSec % 60;
      const min = parseInt(totalSec / 60);
      showDuration.value = `${min < 10 ? `0${min}` : min}:${sec < 10 ? `0${sec}` : sec}`;
    };

    const showCanvas = () => {
      let canvas = document.getElementById("canvas");
      const ctx = canvas.getContext("2d");
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.arc(30, 30, 28, 0, (3 * Math.PI) / 2, true);
      ctx.strokeStyle = "#2A2C2D";
      ctx.stroke();
    };

    watch(showCanvasLoading, (newVal) => {
      console.log(newVal);
      if (newVal) {
        showCanvas();
      } else {
        let canvas = document.getElementById("canvas");
        if (canvas) {
          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, 60, 60);
        }
      }
    });

    const windowSizeChange = () => {
      window.addEventListener("resize", () => {
        innerWidth.value = window.innerWidth;
      });
    };

    const wxShare = () => {
      let _playInfo = playInfo.value;
      wxSdk.getJSSDK({
        title: _playInfo.name,
        desc: _playInfo.columnsName,
        linkurl: `https://app.gztv.com/hcfmshare/#/ColumnsPlay?id=${_playInfo.id}&columnsId=${_playInfo.columnsId}`,
        img: _playInfo.pictureUrl,
      });
    };

    onMounted(async () => {
      showCanvasLoading.value = true;
      await getProgramInfo(route.query.id);
      await getRankInfo();
      getAverageScore();
      getDuration();
      windowSizeChange();
      wxShare();
    });

    return {
      playInfo,
      rankInfo,
      audioRef,
      toHtmlUrl,
      innerWidth,
      averageScore,
      showIntroBtn,
      showDuration,
      showCanvasLoading,
      ...usePopupLogicProps,
      ...useOptionsWrapperLogicProps,
    };
  },
});

const useOptionsWrapperLogic = (route, audioRef, playInfo, showCanvasLoading, getProgramInfo) => {
  const playList = ref([]);
  const isDrag = ref(false);
  const currentTime = ref(0);
  const progressNum = ref(0);
  const tmpCurrentTime = ref(0);
  const showPlayTypeTip = ref(false);
  const playTypeName = ref("顺序播放");
  const showCurrentTime = ref("00:00");
  const playType = ref("sequentialPlay");
  const playStatus = ref("v-icon-pause-circle");

  const playTypeImgMap = {
    sequentialPlay: require("@/assets/image/sequence.png"),
    randomPlay: require("@/assets/image/random.png"),
    loopPlayback: require("@/assets/image/single.png"),
    singlePlay: require("@/assets/image/infinite.png"),
  };

  const changePlayType = () => {
    showPlayTypeTip.value = true;
    setTimeout(() => {
      showPlayTypeTip.value = false;
    }, 1500);
    const _playType = playType.value;
    playType.value =
      _playType === "sequentialPlay"
        ? "loopPlayback"
        : _playType === "loopPlayback"
        ? "randomPlay"
        : _playType === "randomPlay"
        ? "singlePlay"
        : _playType === "singlePlay"
        ? "sequentialPlay"
        : "";
    const __playType = playType.value;
    switch (__playType) {
      case "sequentialPlay": {
        getIdsByColumnsId();
        break;
      }
      case "randomPlay": {
        getIdsByColumnsId();
        playList.value = shuffle(playList.value);
        break;
      }
      case "loopPlayback": {
        getIdsByColumnsId();
        break;
      }
      case "singlePlay": {
        playList.value = [playInfo.value.id];
        break;
      }
    }
  };

  const changePlayStatus = () => {
    const _playStatus = playStatus.value;
    if (_playStatus === "v-icon-play-circle") {
      audioRef.value.play();
      playStatus.value = "v-icon-pause-circle";
    } else {
      audioRef.value.pause();
      playStatus.value = "v-icon-play-circle";
    }
  };

  const pause = () => {
    playStatus.value = "v-icon-play-circle";
  };

  const ready = () => {
    setTimeout(() => {
      showCanvasLoading.value = false;
    }, 300);
    playStatus.value = "v-icon-pause-circle";
  };

  const error = (e) => {
    console.log(e);
  };

  const updateTime = (e) => {
    currentTime.value = e.target.currentTime;
    // 节流操作
    if (tmpCurrentTime.value !== Math.floor(currentTime.value)) {
      tmpCurrentTime.value = Math.floor(currentTime.value);
      getCurrentTime();
    }
  };

  const end = () => {
    console.log("end");
    handleClickNextIcon();
  };

  const getCurrentTime = () => {
    let _currentTime = Math.floor(currentTime.value);
    let _min = parseInt(_currentTime / 60);
    let _sec = _currentTime % 60;
    showCurrentTime.value = `${_min < 10 ? `0${_min}` : _min}:${_sec < 10 ? `0${_sec}` : _sec}`;
    if (!isDrag.value) {
      progressNum.value = Math.floor((_currentTime / playInfo.value.duration) * 100);
    }
  };

  const onChangeSlider = (value) => {
    showCanvasLoading.value = true;
    let duration = playInfo.value.duration;
    let _currentTime = Math.floor((duration / 100) * value);
    currentTime.value = _currentTime;
    audioRef.value.currentTime = _currentTime;
    getCurrentTime();
    setTimeout(() => {
      isDrag.value = false;
    }, 100);
    if (audioRef.value.paused) {
      audioRef.value.play();
    }
  };

  const dragStart = () => {
    isDrag.value = true;
  };

  const sliderModelValue = (value) => {
    let duration = playInfo.value.duration;
    let _currentTime = Math.floor((duration / 100) * value);
    currentTime.value = _currentTime;
    let _min = parseInt(_currentTime / 60);
    let _sec = _currentTime % 60;
    showCurrentTime.value = `${_min < 10 ? `0${_min}` : _min}:${_sec < 10 ? `0${_sec}` : _sec}`;
  };

  const getIdsByColumnsId = async () => {
    const { data } = await queryAllIdByColumnsId({
      columnsId: playInfo.value.columnsId,
    });
    playList.value = data.reverse();
  };

  const handleClickPrevIcon = () => {
    PrevAndNextLogic(false);
  };

  const handleClickNextIcon = () => {
    PrevAndNextLogic();
  };

  const PrevAndNextLogic = (isNext = true) => {
    let directionType = null;
    const _playList = playList.value;
    _playList.forEach((item, index) => {
      if (item === playInfo.value.id) {
        if (index === _playList.length - 1) {
          directionType = isNext ? _playList[0] : _playList[index - 1];
        } else if (index === [0]) {
          directionType = isNext ? _playList[index + 1] : _playList[_playList.length - 1];
        } else {
          directionType = isNext ? _playList[index + 1] : _playList[index - 1];
        }
        getProgramInfo(directionType);
      }
    });
  };

  watch(playInfo, (newVal) => {
    if (newVal) {
      getIdsByColumnsId();
    }
  });

  watch(
    playType,
    (newVal) => {
      switch (newVal) {
        case "sequentialPlay": {
          playTypeName.value = "顺序播放";
          break;
        }
        case "randomPlay": {
          playTypeName.value = "随机播放";
          break;
        }
        case "loopPlayback": {
          playTypeName.value = "循环播放";
          break;
        }
        case "singlePlay": {
          playTypeName.value = "单曲循环";
          break;
        }
      }
    },
    {
      immediate: true,
    }
  );

  return {
    playType,
    playStatus,
    progressNum,
    playTypeName,
    playTypeImgMap,
    showPlayTypeTip,
    showCurrentTime,
    end,
    pause,
    ready,
    error,
    dragStart,
    updateTime,
    changePlayType,
    onChangeSlider,
    changePlayStatus,
    sliderModelValue,
    handleClickPrevIcon,
    handleClickNextIcon,
  };
};

const usePopupLogic = (playInfo, getProgramInfo) => {
  const page = ref(1);
  const order = ref(-1);
  const programList = ref([]);
  const isFinished = ref(false);
  const listLoading = ref(true);
  const showColumnListPopup = ref(false);
  const sortUpImg = require("@/assets/image/sort-up.png");
  const sortDownImg = require("@/assets/image/sort-down.png");

  const getProgramList = async () => {
    console.log(page.value);
    const result = await queryHistoryProgramByName({
      flag: "set",
      columnsId: playInfo.value.columnsId,
      page: page.value,
      rows: 10,
      order: order.value,
    });
    programList.value = [...programList.value, ...result.data.pageList];
    listLoading.value = false;
    if (page.value >= result.data.totalPage) {
      isFinished.value = true;
    }
  };

  const loadList = () => {
    page.value = page.value + 1;
    getProgramList();
  };

  const showProgramListPopup = () => {
    showColumnListPopup.value = true;
    if (programList.value.length > 0) {
      return;
    }
    getProgramList();
  };

  const changeSort = () => {
    if (order.value === -1) {
      order.value = 1;
    } else {
      order.value = -1;
    }
    programList.value = [];
    page.value = 1;
    isFinished.value = false;
    getProgramList();
  };

  const handleClickPgcItem = (item) => {
    getProgramInfo(item.id);
  };

  return {
    order,
    sortUpImg,
    isFinished,
    sortDownImg,
    listLoading,
    programList,
    showColumnListPopup,
    loadList,
    changeSort,
    handleClickPgcItem,
    showProgramListPopup,
  };
};
</script>

<style lang="scss" scoped>
.columns-play {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  max-width: 450px;
  margin: 0 auto;

  .page-body {
    width: 100%;
    box-sizing: border-box;
    padding: 0 25px;
    margin-top: 65px;

    .column-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc(100% - 50px);
      height: 250px;
      background: #41506a;
      border-radius: 8px;
      box-sizing: border-box;
      padding: 20px;
      margin: 0 25px;

      .img-wrapper {
        position: relative;
        width: 100%;
        height: 100%;

        & > img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }

        .play-num-wrapper {
          position: absolute;
          display: flex;
          align-items: center;
          right: 4px;
          top: 8px;
          background: rgba(83, 97, 118, 0.92);
          border-radius: 12px;
          font-size: 12px;
          color: #feffff;
          padding: 3px 10px;

          & > img {
            width: 10px;
            height: 10px;
            margin-right: 2px;
          }
        }
      }
    }

    .column-content {
      width: 100%;
      margin-top: 15px;

      .column-title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        // color: #7a90be;
        color: #fffefe;
        line-height: 25px;
      }

      .column-intro {
        display: flex;
        align-items: center;
        margin-top: 10px;

        & > span {
          width: 150px;
          max-width: 150px;
          margin-right: 15px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          // color: #7a90be;
          color: #fffefe;
        }

        .column-intro-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          width: 100px;
          height: 24px;
          background: #465166;
          // color: #7a90be;
          color: #fffefe;
          border-radius: 4px;
        }
      }

      .column-tag {
        display: flex;
        align-items: center;
        margin-top: 10px;

        .column-tag-star {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 50px;
          height: 23px;
          background: #484b63;
          font-size: 12px;
          color: #d1ad0e;
          border-radius: 4px;

          & span {
            margin-left: 4px;
          }
        }

        .column-tag-num {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 111px;
          height: 23px;
          background: #484b63;
          font-size: 12px;
          color: #d1ad0e;
          margin-left: 10px;
          border-radius: 4px;

          & > span {
            margin-right: 10px;
          }
        }
      }

      .column-name {
        margin-top: 10px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fffefe;
      }
    }

    .slider-wrapper {
      display: flex;
      align-items: center;
      margin-top: 20px;

      .slider-current {
        margin-right: 5px;
      }

      .slider-total {
        margin-left: 5px;
      }

      & > span {
        font-size: 10px;
        color: #fff;
      }

      .custom-button {
        // width: 26px;
        color: #090909;
        font-size: 10px;
        line-height: 18px;
        text-align: center;
        background-color: #fefefe;
        border-radius: 100px;
        padding: 0 4px;
      }
    }

    .options-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fefefe;
      margin-top: 20px;

      .options-wrapper-btn {
        position: relative;
        height: 58px;
        display: flex;
        align-items: center;
        justify-content: center;

        .play-icon {
          font-size: 58px;
        }

        .options-icon {
          font-size: 22px;
        }

        #canvas {
          position: absolute;
          animation: my-rotate infinite 0.8s linear;
        }

        @keyframes my-rotate {
          0% {
            transform: rotate(0deg);
          }

          50% {
            transform: rotate(180deg);
          }

          100% {
            transform: rotate(360deg);
          }
        }

        .options-wrapper-btn-img {
          width: 24px;
          height: 24px;
        }

        .playtype-tip {
          position: absolute;
          top: 0;
          display: flex;
          align-items: center;
          left: 50%;
          transform: translate(-40%, -20px);
          font-size: 12px;
          color: #fffefe;
          width: 75px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          background: #303133;
          letter-spacing: 1px;
          text-indent: 1px;

          .close-icon {
            color: #fffefe;
            margin-left: 3px;
          }

          &::after {
            position: absolute;
            content: "";
            left: 40%;
            bottom: 0;
            transform: translateY(5px);
            border-style: solid;
            border-width: 6px 4px 0 4px;
            border-color: #303133 transparent transparent transparent;
          }

          @keyframes shrink {
            0% {
              opacity: 1;
            }
            50% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
  }

  .popup-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    .popup-header {
      width: 100%;
      height: 80px;
      box-sizing: border-box;
      padding: 0 20px;
      overflow: hidden;

      .header-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        height: 40px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #373d44;
      }

      .header-options {
        height: 40px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6d6e6f;

        .header-options-sort {
          display: flex;
          align-items: center;
          & > img {
            width: 20px;
            height: 20px;
            margin-right: 5px;
          }
        }
      }
    }

    .popup-content {
      width: 100%;
      height: 100%;
      flex: 1;
      overflow: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      box-sizing: border-box;
      padding-left: 20px;

      .popup-content-item {
        display: flex;
        align-items: center;
        width: 100%;
        height: 50px;
        box-sizing: border-box;
        padding-right: 20px;
        border-bottom: 1px solid #f5f5f5;

        &:last-child {
          border-bottom: none;
        }

        .content-item-num {
          width: 30px;
          height: 100%;
          display: flex;
          align-items: center;
          font-size: 16px;
          font-style: italic;
          color: #9c9d9e;
        }

        .content-item-name {
          width: 100%;
          flex: 1;
          margin-right: 30px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #474a4e;
        }

        .content-item-name-active {
          color: #e73828;
        }

        .content-item-download {
          position: relative;
          width: 30px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .content-item-download-icon {
            position: absolute;
            right: 0;
            bottom: 0;
            color: #00cc66;
            transform: translate(40%, -90%);
            background: #fff;
            // border: 2px solid #fff;
            box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
            border-radius: 50%;
            overflow: hidden;
          }
        }
      }
    }

    .popup-bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 50px;
      font-size: 20px;
      color: #2c2d2e;
      letter-spacing: 2px;
      box-shadow: 0 -3px 12px rgba(204, 204, 204, 0.7);
    }
  }

  @media screen and (min-height: 735px) {
    .column-wrapper {
      width: 100% !important;
      height: calc(100vw - 50px) !important;
      max-height: 300px !important;
      background: #41506a;
      border-radius: 8px;
      box-sizing: border-box;
      margin: 0 !important;
      padding: 20px;
    }
  }

  @media screen and (min-height: 666px) {
    .column-wrapper {
      width: 100% !important;
      height: calc(100vw - 60px) !important;
      max-height: 300px !important;
      background: #41506a;
      border-radius: 8px;
      box-sizing: border-box;
      margin: 0 !important;
      padding: 30px 35px;
    }
  }
}
</style>
